// extracted by mini-css-extract-plugin
export default {"root":"ukm_JxCLG9X_69rlWwWV","pagination":"hZOJzLny8o1d41kbj3g5","page-size":"LOCZknC6i0S6JE5FrjDo","pageSize":"LOCZknC6i0S6JE5FrjDo"};